export default {
  SET_MAINTENANCE(state, data) {
    state.maintenance = data;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/maintenance/maintenanceMutation.js